import { GisStandInconsistencyCase } from 'orchestrator';
import {
    MenuCategories,
    MenuSubcategories,
    MENU_CATEGORY_KEY,
    MENU_NAME_SUFFIX,
    MENU_SUBCATEGORY_KEY,
} from '@zendra/shared';
import { GroupSeed } from './gis-inconsistency-dashboard.models';

const GROUP_CARD_I18N_PREFIX = 'Geographic::Entity.GisInconsistencyGroupCard';
const STAND_INCONSISTENCY_I18N_PREFIX = 'Geographic::Entity.GisStandInconsistency';

const groupCardLabel = (suffix: string): string => `${GROUP_CARD_I18N_PREFIX}.${suffix}`;
const standInconsistencyLabel = (suffix: string): string =>
    `${STAND_INCONSISTENCY_I18N_PREFIX}.${suffix}`;

export const GROUP_SEEDS: GroupSeed[] = [
    {
        key: 'stands',
        title: groupCardLabel('Stands'),
        iconClass: 'bi bi-grid',
        tone: 'stands',
        items: [
            [
                'standsOnlyInGis',
                standInconsistencyLabel('OnlyInGis'),
                {
                    routePath: 'gis-stand-inconsistency-only-in-gis',
                    countCase: GisStandInconsistencyCase.OnlyInGis,
                },
            ],
            [
                'standsOnlyInZendra',
                standInconsistencyLabel('OnlyInZendra'),
                {
                    routePath: 'gis-stand-inconsistency-only-in-zendra',
                    countCase: GisStandInconsistencyCase.OnlyInZendra,
                },
            ],
            [
                'standsAreaDifference',
                groupCardLabel('StandsAreaDifference'),
                {
                    routePath: 'gis-stand-area-difference',
                },
            ],
            [
                'standsDisabledInZendra',
                standInconsistencyLabel('DisabledInZendra'),
                {
                    routePath: 'gis-stand-inconsistency-disabled-in-zendra',
                    countCase: GisStandInconsistencyCase.DisabledInZendra,
                },
            ],
        ],
    },
    {
        key: 'otherUses',
        title: groupCardLabel('OtherUses'),
        iconClass: 'bi bi-sign-intersection-side',
        tone: 'other-uses',
        items: [
            ['otherUsesOnlyInGis', groupCardLabel('OtherUsesOnlyInGis'), { routePath: 'other-use-inconsistency-only-in-gis' }],
            ['otherUsesOnlyInZendra', groupCardLabel('OtherUsesOnlyInZendra'), { routePath: 'other-use-inconsistency-only-in-zendra' }],
        ],
    },
    {
        key: 'properties',
        title: groupCardLabel('Properties'),
        iconClass: 'bi bi-file-earmark-text',
        tone: 'properties',
        items: [
            ['propertiesOnlyInGis', groupCardLabel('PropertiesOnlyInGis'), { routePath: 'gis-register-inconsistency-only-in-gis' }],
            ['propertiesOnlyInZendra', groupCardLabel('PropertiesOnlyInZendra'), { routePath: 'gis-register-inconsistency-only-in-zendra' }],
        ],
    },
    {
        key: 'protectedAreas',
        title: groupCardLabel('ProtectedAreas'),
        iconClass: 'bi bi-shield-check',
        tone: 'protected-areas',
        items: [
            ['protectedAreasOnlyInGis', groupCardLabel('ProtectedAreasOnlyInGis'), { routePath: 'gis-protected-area-inconsistency-only-in-gis' }],
            ['protectedAreasOnlyInZendra', groupCardLabel('ProtectedAreasOnlyInZendra'), { routePath: 'gis-protected-area-inconsistency-only-in-zendra' }],
        ],
    },
];

export const GISINCONSISTENCYDASHBOARD_CONFIG = {
    entityName: 'GisInconsistencyDashboard',
    localizationKey: 'Geographic::Entity.GisInconsistencyDashboard',
    permission: 'PlanningGeography.GisInconsistencyDashboard',
    showInMenu: true,
    menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
    menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
